import { observer } from "mobx-react-lite";
import React from "react";
import { Grid, Button, Message, MessageHeader } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { useStore } from "../../../app/stores/store";
import PageHeader from "../../../app/layout/PageHeader";


type Props = {
  handleSave: Function;
  applyToAll: boolean;
}

export default observer(function ApplyARToAll({ handleSave, applyToAll }: Props) {
  const { t } = useTranslation(["common", "translation"]);
  const { modalStore } = useStore();
  

  return (
    <Grid stackable>
      <Grid.Row columns={1}>
        <Grid.Column>
          <PageHeader
            type={"h1"}
            header={applyToAll ? t("notApplyToAll", { ns: "accountsReceivable" }) : t("applyToAll", { ns: "accountsReceivable" })}
            divider={true}
            addTitle={false}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Message info>
            <MessageHeader>
              {applyToAll ? t("notApplyToAllDisclaimer", { ns: "accountsReceivable" }) : t("applyToAllDisclaimer", { ns: "accountsReceivable" })}
            </MessageHeader>
          </Message>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Button
            color="green"
            icon="check"
            content={t("yes", { ns: "common" })}
            onClick={() => {
              handleSave();
              modalStore.closeModal();
            }}
          />
          <Button
            color="grey"
            content={t("cancel", { ns: "common" })}
            onClick={() => {
              modalStore.closeModal();
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
});
